'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _vueResource = require('vue-resource');

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueFloatthead = require('vue-floatthead');

var _vueFloatthead2 = _interopRequireDefault(_vueFloatthead);

var _vueEasyToast = require('vue-easy-toast');

var _vueEasyToast2 = _interopRequireDefault(_vueEasyToast);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _vTooltip = require('v-tooltip');

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _bootstrapVue = require('bootstrap-vue');

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueCookies = require('vue-cookies');

var _vueCookies2 = _interopRequireDefault(_vueCookies);

var _vueSessionstorage = require('vue-sessionstorage');

var _vueSessionstorage2 = _interopRequireDefault(_vueSessionstorage);

var _vueFormulate = require('@braid/vue-formulate');

var _vueFormulate2 = _interopRequireDefault(_vueFormulate);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = Intl.NumberFormat().resolvedOptions().locale;

_vue2.default.use(_vueSessionstorage2.default);

_vue2.default.use(_bootstrapVue2.default);

_vue2.default.use(_vTooltip2.default);

require('nodep-date-input-polyfill');

_vue2.default.use(_vueFloatthead2.default);

_vue2.default.use(_vueEasyToast2.default);

_vue2.default.use(_vueFormulate2.default);

_vue2.default.use(_vueCookies2.default);

_vue2.default.leadscorz = {};

_vue2.default.leadscorz.deep_clone = function (obj) {
  return JSON.parse((0, _stringify2.default)(obj));
};

_vue2.default.leadscorz.deep_find = function (obj, path) {
  var paths = path.split('.'),
      current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined) {
      return undefined;
    } else {
      current = current[paths[i]];
    }
  }
  return current;
};

_vue2.default.leadscorz.handleError = function (response, displayAlert) {
  console.error(response, displayAlert);

  if (displayAlert) {
    var errorTitle = response.statusText || 'Unexpected error';
    var errorText = response.body['detail'] || response.bodyText;
    _vue2.default.toast(errorTitle + "<br>" + errorText, { className: ['et-error'] });
  }
};

_vue2.default.leadscorz.array_equal = require('is-arrays-equal');

_vue2.default.router = _router2.default;

_vue2.default.use(_vueResource2.default);

global.API = new _api2.default(_vue2.default.http);

global.BUS = new _vue2.default();

var component = require('./App.vue');

component.router = _vue2.default.router;
component.store = _store2.default;

_vue2.default.http.options.root = process.env.API_ROOT;
_vue2.default.http.options.credentials = true;

_vue2.default.http.interceptors.push(function (request, next) {

  var csrftoken = _vue2.default.$cookies.get(process.env.LSBACKEND_CSRF_COOKIE_NAME);
  if (csrftoken) {
    request.headers.set('X-CSRFToken', csrftoken);
  }

  next(function (response) {
    if (response.status === 401) {
      _vue2.default.$store.commit('unsetUser');
      _vue2.default.router.push({ name: 'login' });
      window.location.reload();
    } else if (response.status === 404) {
        _vue2.default.leadscorz.handleError(response, true);
      }
  });
});

_vue2.default.filter("formatTimestamp", function (value) {
  var d = new Date(value);
  if (component.store.state.user) {
    var localtz = component.store.state.user.timezone;
    return d.toLocaleString(locale, { timeZone: localtz });
  }
  return d.toString();
});

_vue2.default.filter("formatDate", function (value) {
  var d = new Date(value);
  if (component.store.state.user) {
    var localtz = component.store.state.user.timezone;
    return d.toLocaleDateString(locale, { timeZone: localtz });
  }
  return d.toString();
});

_vue2.default.filter("percentage", function (value, decimals) {
  if (isNaN(value)) {
    return "-";
  }

  if (!value) {
    value = 0;
  }

  if (!decimals) {
    decimals = 2;
  }

  value = value * 100.0;

  return value.toFixed(decimals) + "%";
});

_vue2.default.filter("decimal", function (value, decimals) {
  if (value == '-') return value;
  if (!value) value = 0;
  if (!decimals) decimals = 2;

  return value.toFixed(decimals);
});

_vue2.default.filter("ifNull", function (value, defaultValue) {
  if (typeof value == 'undefined' || !value) {
    return defaultValue;
  }
  return value;
});

_vue2.default.filter("join", function (value, glue) {
  if (Array.isArray(value)) {
    return value.join(glue);
  }
  return value;
});

_vue2.default.filter("uppercase", function (value) {
  return value.toString().toUpperCase();
});

_vue2.default.filter("lowercase", function (value) {
  return value.toString().toLowerCase();
});

new _vue2.default(component).$mount('#app');


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 140
// module chunks = 0